<style lang="less">
@import "../styles/menu.less";
// 层次颜色
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  border-right: 4px solid #2d8cf0;
}
.ivu-menu-submenu {
  .ivu-menu {
    background-color: #f8f8f9;
    // background-color: #EBF7FF;
    border: 2px solid #eeeeee;
  }
}
</style>

<template>
  <Menu
    ref="sideMenu"
    :active-name="activeName"
    :open-names="openNames"
    :theme="menuTheme"
    width="auto"
    style="height:100%"
    @on-select="changeMenu"
    accordion
  >
    <div v-for="(item, index) in menuList" :key="index">
      <MenuItem
        v-if="item.children.length <= 1 && (item.isShow || item.children[0].isShow)"
        :name="item.children[0].name"
        :key="'menuitem' + item.name"
      >
      
        <div class="IconBox">
          <Icon
            :type="item.children[0].icon || item.icon"
            :size="iconSize"
            :key="'menuicon' + item.name"
          ></Icon>
        </div>
        <span class="layout-text" :key="'title' + item.name">{{
          itemTitle(item.children[0])
        }}</span>
      </MenuItem>
      <Submenu
        v-if="item.children.length > 1 && item.isShow"
        :name="item.name"
        :key="item.name"
      >
        <div slot="title" style="display: inline-block;white-space: nowrap;">
          <div class="IconBox">
            <Icon :type="item.icon" :size="iconSize"></Icon>
          </div>
          <span class="layout-text">{{ itemTitle(item) }}</span>
        </div>
        <div v-for="(child, index) in item.children" :key="index">
          <MenuItem :name="child.name" :key="'menuitem' + child.name" v-if="child.isShow">
            <div class="IconBox">
              <Icon
                :type="child.icon"
                :size="iconSize"
                :key="'icon' + child.name"
              ></Icon>
            </div>
            <span class="layout-text" :key="'title' + child.name">{{
              itemTitle(child)
            }}</span>
          </MenuItem>
        </div>
      </Submenu>
    </div>
  </Menu>
</template>

<script>
export default {
  name: "sidebarMenu",
  props: {
    menuList: Array,
    // iconSize: Number,
    menuTheme: {
      type: String,
      default: "light",
    },
    openNames: {
      type: Array,
    },
  },

  data() {
    return {
      iconSize: 16,
      // 菜单选中状态
      activeName:"",
      // 上一个跳转路由的名称
      previousRouteName:"", 
    }
  },
  
  computed: {
    // $route.name
    // ActiveName(){
    //   //解决编辑页 菜单失去选中。
    //   if (typeof this.$route.meta.parentName != "undefined") {
    //     // this.$store.commit("addOpenSubmenu", this.$route.meta.menuName);  //添加后打开三级页面后菜单无法收缩
    //     return this.$route.meta.parentName;
    //   } else {
    //     return this.$route.name;
    //   }
    // }
  },
  methods: {
    setActiveName() {
      //解决编辑页 菜单失去选中。
      if (typeof this.$route.meta.parentName != "undefined") {
        this.$nextTick(() => {
          if (this.$route.meta.parentName instanceof Array) {
            if(!this.previousRouteName){
              this.previousRouteName = localStorage.getItem("previousRouteName");
            }
            this.$route.meta.parentName.map((item)=>{
              if (item == this.previousRouteName) {
                this.activeName = item;
              }
            })
          } else{
            this.activeName = this.$route.meta.parentName;
          }
          if (this.$refs.sideMenu) {
            this.$refs.sideMenu.updateOpened();
            this.$refs.sideMenu.updateActiveName();
          }
        })
      } else {
        this.$nextTick(() => {
          this.activeName = this.$route.name;
          if (this.$refs.sideMenu) {
            this.$refs.sideMenu.updateOpened();
            this.$refs.sideMenu.updateActiveName();
          }
        })
      }
    },
    changeMenu(active) {
      this.$emit("on-change", active);
    },
    itemTitle(item) {
      if (typeof item.title === "object") {
        return this.$t(item.title.i18n);
      } else {
        return item.title;
      }
    },
  },
  watch: {
    openNames(val) {
      this.$nextTick(() => {
        //解决菜单会展开多个的问题
        if (this.$refs.sideMenu) {
          // this.$refs.sideMenu.$children.forEach(item => {
          //   item.opened = false;
          // });
          this.$refs.sideMenu.updateOpened();
          this.$refs.sideMenu.updateActiveName();
        }
      });
    },
    menuList: {
      immediate: true,
      handler(val) {
        if (val.length > 0) {
          this.setActiveName();
        }
      }
    },
    '$route'(to, from) {  
      if (from.name) {
        this.previousRouteName = from.name;
        localStorage.setItem("previousRouteName",this.previousRouteName);
      }
      this.setActiveName();
    }
  },
  mounted() {
    
  },
  updated() {},
};
</script>



// WEBPACK FOOTER //
// src/views/main-components/shrinkable-menu/components/sidebarMenu.vue